import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error';

export interface ToastState {
  isVisible: boolean;
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly state$$ = new BehaviorSubject<ToastState>({
    isVisible: false,
    message: '',
    type: 'success',
  });

  readonly state$ = this.state$$.asObservable();

  private hideTimeout: ReturnType<typeof setTimeout> | null = null;

  show(message: string, type: ToastType = 'success', duration: number = 5000): void {
    // Clear any existing timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.state$$.next({
      isVisible: true,
      message,
      type,
    });

    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.state$$.next({
      ...this.state$$.value,
      isVisible: false,
    });
  }

  success(message: string, duration?: number): void {
    this.show(message, 'success', duration);
  }

  error(message: string, duration?: number): void {
    this.show(message, 'error', duration);
  }
}
